import type {Libraries, LoadScriptProps} from '@react-google-maps/api'

export const googleMapsLibraries: Libraries = ['drawing', 'places', 'marker']

export const googleMapsLoaderOptions: LoadScriptProps = {
  id: 'google-map-script',
  googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API,
  // DrawingManager was removed from the weekly channel in v3.65.
  version: '3.64',
  libraries: googleMapsLibraries,
}
